export default __webpack_public_path__ + "static/media/HomesAndGarden.479bd613.svg";